<template>

	<div class="controls">
		<div class="text-center">
			<i class="fal fa-circle-notch fa-spin fa-fw" v-if="loading"></i>
		</div>
		<div>
			<div class="">
          <select v-model="selected" @change="toggleSetting">
                  <option v-for="row in arrayOfRowNames" :value="row.value">
										{{ row.title }}
									</option>
          </select>
			</div>
		</div>
	</div>
</template>


<script>
'use strict';
	export default {
		name: 'Dropdown',
		data() {
			return {
				selected: null,
				loading: true,
			}
		},

		props: {
			setting: {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.settingName
				}

			},
			label: {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.settingLabel
				}
			},
			arrayOfRowNames: {
				required: false,
				type: Array,
				default: function() {
					let array = [];
					let attributeNameStart = 'this.$root.$el.dataset.settingRowName';
						for (var i = 0; i < 20; i++) {
					 		 let indexPositionAsAString = JSON.stringify(i);
							 let attributeName = attributeNameStart + indexPositionAsAString;
							 let javascriptData = eval(attributeName);
							 if(javascriptData != undefined){
								 array.push(JSON.parse(javascriptData))
							 }
						}
					return array;
				}
			},
			testArray: {
				required: false,
        default: function() {
					return this.$root.$el.dataset.settingTestObject
				}
			}
		},

		methods: {

			async getSetting() {
				try {


					this.loading = true;
					const url = Routing.generate('ApiBundle_get_setting', {setting: this.setting});
					const request = new Request(url, {
						method: 'GET',
						credentials: 'same-origin'
					});

					const setting = await fetch(request);
					const settingJson = await setting.json();
					this.loading = false;
					this.selected = settingJson.data;
				} catch(error) {
					console.error(error);
				}
			},

			async toggleSetting() {
				try {

					this.loading = true;
					const url = Routing.generate('ApiBundle_dropdown_setting', {setting: this.setting, value: this.selected});
					const request = new Request(url, {
						method: 'POST',
						credentials: 'same-origin'
					});

					const statusRequest = await fetch(request);
					const statusJson = await statusRequest.json();
					this.loading = false;
				} catch(error) {
					console.error(error);
				}
			}
		},

		components: {},
		beforeMount() {},
		mounted() {
			this.getSetting();
		},
		created() {},
		updated() {}
	};
</script>


<style scoped>

[v-cloak] {
	display: none;
}

.controls {
	display: grid;
	grid-template-columns: 1fr 11fr;
	align-items: center;
}

</style>
